import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';
import { FontIcon, FontIcons } from '@brandfolder/react';

interface EnableMultiLanguageAssetDetails {
  defaultEnabled: boolean | null;
  onUpdateSuccess: SetStateDispatch<boolean>;
}

const MultiLanguageAssetDetails: FunctionComponent<EnableMultiLanguageAssetDetails> = ({
  defaultEnabled,
  onUpdateSuccess
}) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled || false}
    description={
      <a className='mlad-article-link' href='https://help.brandfolder.com/hc/en-us/articles/360048044553-Multi-Language-Asset-Details-and-Bulk-Translations' target="_blank">
        {bfTranslate('Learn more')}
        <FontIcon aria-hidden icon={FontIcons.NewTab} />
      </a>
    }
    errorTitle={bfTranslate('Error updating Multi Language Asset Details setting. Please contact support.')}
    id='enable-multi-language-asset-details'
    onUpdateSuccess={onUpdateSuccess}
    successTitle={bfTranslate('Multi Language Asset Details setting updated!')}
    title={bfTranslate('Multi Language Asset Details')}
    updateResourceKey='multiLanguageAssetDetailsEnabled'
  />
);

export default MultiLanguageAssetDetails;